import { DateTime } from 'luxon';
const MONTH_ABBR = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
const fromDateTime = (dt) => dt.toUTC().startOf('month').toISODate();
/**
 * Normalize an ISO date string (e.g. a `date` column read back from the DB) to a
 * usage month. Any day-of-month is snapped to the first; always UTC.
 */
export const toUsageMonth = (iso) => fromDateTime(DateTime.fromISO(iso, { zone: 'utc' }));
/** `a >= b` for usage months (lexical, but expresses the intent). */
export const usageMonthGte = (a, b) => a >= b;
/** The usage month `n` months after `month` (n may be negative). */
export const addMonths = (month, n) => DateTime.fromISO(month, { zone: 'utc' })
    .plus({ months: n })
    .toISODate();
/** Display form, e.g. `Nov 2026`. */
export const formatUsageMonth = (month) => {
    const [year, m] = month.split('-');
    return `${MONTH_ABBR[Number(m) - 1]} ${year}`;
};
/** The first day of the last `count` months, most recent first (index 0 = current). */
export const recentMonths = (count, now = DateTime.utc()) => {
    const current = now.toUTC().startOf('month');
    return Array.from({ length: count }, (_, i) => current.minus({ months: i }).toISODate());
};
//# sourceMappingURL=usageMonth.js.map